import { getSystemTimeApi } from '@/api/hall/bid-open-hall'
import DateUtils from '@/utils/date'

let systemTimeInterval = null

const state = {
  // 校准时的系统日期时间
  staticDate: DateUtils.format(new Date(), 'yyyy-MM-dd hh:mm:ss'),
  // 系统日期时间
  systemDate: DateUtils.format(new Date(), 'yyyy.MM.dd hh:mm:ss'),
  // 系统时间
  systemTime: DateUtils.format(new Date(), 'hh:mm:ss'),
  // 系统时间时间戳模式
  systemMillisecond: 0,
  // 校准记数
  count: 0
}

const mutations = {
  SET_STATIC_DATE: (state, date) => {
    state.staticDate = date
  },

  SET_SYSTEM_DATE: (state, date) => {
    state.systemDate = date
  },

  SET_SYSTEM_TIME: (state, time) => {
    state.systemTime = time
  },

  SET_SYSTEM_MILLISECOND: (state, millisecond) => {
    state.systemMillisecond = millisecond
  },

  SET_COUNT: (state, count) => {
    state.count = count
  }
}

const actions = {
  /**
   * 获取服务器时间
   */
  getSystemTime({ commit, dispatch }, startClock = false) {
    return new Promise((resolve, reject) => {
      getSystemTimeApi()
        .then(res => {
          commit(
            'SET_STATIC_DATE',
            DateUtils.format(new Date(res.data), 'yyyy-MM-dd hh:mm:ss')
          )
          commit('SET_SYSTEM_MILLISECOND', res.data)
          commit(
            'SET_SYSTEM_DATE',
            DateUtils.format(new Date(res.data), 'yyyy.MM.dd hh:mm:ss')
          )
          if (startClock) dispatch('startClock')
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * 启动时钟
   */
  startClock({ commit, dispatch }) {
    clearInterval(systemTimeInterval)
    systemTimeInterval = null
    systemTimeInterval = setInterval(() => {
      if (state.count === 60) {
        dispatch('cleanSystemTimeInterval')
        dispatch('getSystemTime')
        commit('SET_COUNT', 0)
      }

      commit('SET_SYSTEM_MILLISECOND', state.systemMillisecond + 1000)
      const tempDate = new Date(state.systemMillisecond)
      commit('SET_COUNT', state.count + 1)
      commit(
        'SET_SYSTEM_DATE',
        DateUtils.format(tempDate, 'yyyy.MM.dd hh:mm:ss')
      )
      commit('SET_SYSTEM_TIME', DateUtils.format(tempDate, 'hh:mm:ss'))
    }, 1000)
  },

  /**
   * 清除定时器
   */
  cleanSystemTimeInterval() {
    if (systemTimeInterval) {
      clearInterval(systemTimeInterval)
      systemTimeInterval = null
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
